import type { HeroVariant, TimeBucket } from './heroAnalytics';

export type HeroCopy = {
  subtitle: string;
  prefix: string;
  cta: string;
};

export const getHeroCopy = (variant: HeroVariant): HeroCopy => {
  if (variant === 'B') {
    return {
      subtitle: "When the city sleeps, we deliver.",
      prefix: 'Tap for',
      cta: 'Order in 30 min',
    };
  }
  return {
    subtitle: "Everyone's asleep. We're not.",
    prefix: 'Get',
    cta: 'Browse stores',
  };
};

// Time-bucket aware rotating prompts. Variant tweaks tone slightly.
export const getRotatingPrompts = (
  variant: HeroVariant,
  bucket: TimeBucket
): string[] => {
  const sets: Record<TimeBucket, { A: string[]; B: string[] }> = {
    late_night: {
      A: [
        'a hot pizza 🍕',
        'an ice-cold six-pack 🍺',
        'midnight munchies 🌙',
        'late-night burgers 🍔',
        'wings & chips 🍗',
      ],
      B: [
        'pizza on the way 🍕',
        'beers in 30 min 🍺',
        'snacks for the crew 🍿',
        'a sweet craving 🍫',
        'shisha essentials 💨',
      ],
    },
    deep_night: {
      A: [
        'paracetamol — fast 💊',
        'cough syrup 🤒',
        'nappies & formula 🍼',
        'pads & tampons 🩸',
        'a phone charger 🔌',
        'condoms — discreet 🌙',
      ],
      B: [
        'meds delivered now 💊',
        'baby essentials 🍼',
        'period care 🩸',
        'flu relief 🤧',
        'a charger fast 🔌',
        'late-night essentials ✨',
      ],
    },
    pre_dawn: {
      A: [
        'milk & bread 🥛',
        'fresh coffee ☕',
        'eggs & bacon 🥓',
        'breakfast cereal 🥣',
        'orange juice 🍊',
        'morning meds 💊',
      ],
      B: [
        'breakfast in 30 ☕',
        'milk run 🥛',
        'bacon & eggs 🥓',
        'fresh juice 🍊',
        'pre-shift snacks 🥣',
        'the day starter ✨',
      ],
    },
    daytime: {
      A: [
        'a hot pizza 🍕',
        'groceries delivered 🛒',
        'paracetamol — fast 💊',
        'an ice-cold six-pack 🍺',
        'milk & bread 🥛',
      ],
      B: [
        'pizza in 30 min 🍕',
        'a quick grocery run 🛒',
        'meds at the door 💊',
        'cold drinks 🥤',
        'snacks delivered 🍿',
      ],
    },
  };
  return sets[bucket][variant];
};
